import React from 'react'
import {
  Grid,
  TextField,
  Typography,
  Divider,
  Box
} from '@mui/material'
import {
  FormInputRow,
  ImageUploader
} from '@emerald-works-nova/components'
import ImageDisplay from '../../../../../../../components/image-display'
import { useStyles } from './style'

// Image validation constants
const IMAGE_VALIDATION = {
  MAX_SIZE: 10485760, // 10MB in bytes
  MIN_WIDTH: 800,
  MIN_HEIGHT: 750
}

const HeroSectionForm = ({ section, onChange, isEdit }) => {
  const classes = useStyles()
  console.log('section', section)
  const { header, subHeader, description, cta, imageInfo } = section.data

  const handleFieldChange = (field, value) => {
    onChange(section.order, { ...section, data: { ...section.data, [field]: value } })
  }

  const handleImageUpload = (imgInfo) => {
    handleFieldChange('imageInfo', imgInfo)
  }

  const setImageInfo = (updatedImageInfo) => {
    handleFieldChange('imageInfo', updatedImageInfo)
  }

  const hasImage = imageInfo?.s3Url || imageInfo?.imgUrl

  return (
    <Grid container spacing={3} className={classes.formContainer} data-test='hero-section-form-container'>
      <Grid item xs={12} data-test='hero-section-form-header-container'>
        <FormInputRow
          title='Header'
          description='Main heading for the hero section'
          smallFormTitles
          InputComponent={
            <TextField
              fullWidth
              label='Header'
              value={header || ''}
              onChange={(e) => handleFieldChange('header', e.target.value)}
              variant='outlined'
              data-test='hero-section-form-header-input'
              disabled={!isEdit}
            />
          }
        />
      </Grid>

      <Grid item xs={12} data-test='hero-section-form-subheader-container'>
        <FormInputRow
          title='Subheader'
          description='Supporting headline for the hero section'
          smallFormTitles
          InputComponent={
            <TextField
              fullWidth
              label='Subheader'
              value={subHeader || ''}
              onChange={(e) => handleFieldChange('subHeader', e.target.value)}
              variant='outlined'
              data-test='hero-section-form-subheader-input'
              disabled={!isEdit}
            />
          }
        />
      </Grid>

      <Grid item xs={12} data-test='hero-section-form-description-container'>
        <FormInputRow
          title='Description'
          description='Detailed description for the hero section'
          smallFormTitles
          InputComponent={
            <TextField
              fullWidth
              label='Description'
              value={description || ''}
              onChange={(e) => handleFieldChange('description', e.target.value)}
              variant='outlined'
              multiline
              rows={3}
              data-test='hero-section-form-description-input'
              disabled={!isEdit}
            />
          }
        />
      </Grid>

      <Grid item xs={12} data-test='hero-section-form-cta-container'>
        <FormInputRow
          title='Call-to-Action (CTA)'
          description='Button text for the main action in the hero section'
          smallFormTitles
          InputComponent={
            <TextField
              fullWidth
              label='CTA Button Text'
              value={cta || ''}
              onChange={(e) => handleFieldChange('cta', e.target.value)}
              variant='outlined'
              placeholder='Get Started'
              data-test='hero-section-form-cta-input'
              disabled={!isEdit}
            />
          }
        />
      </Grid>

      <Grid item xs={12} data-test='hero-section-form-image-container'>
        <Typography variant='subtitle1' tabIndex={0} className={classes.imageTitle}>
            Image details
        </Typography>
        <Divider className={classes.imageDivider} />
        {!hasImage ? (
          <Box mt={2}>
            <FormInputRow
              hideTitle
              description='Upload an image to represent this section visually.'
              InputComponent={
                <ImageUploader
                  onDropAccepted={handleImageUpload}
                  imageNamePrefix={`hero-section-form-${section.order}-`}
                  disabled={!isEdit}
                  validation={{
                    maxSize: IMAGE_VALIDATION.MAX_SIZE,
                    accept: '.jpg,.jpeg,.png,.gif',
                    minWidth: IMAGE_VALIDATION.MIN_WIDTH,
                    minHeight: IMAGE_VALIDATION.MIN_HEIGHT
                  }}
                />
              }
            />
          </Box>
        ) : (
          <Box mt={2}>
            <ImageDisplay
              imageInfo={imageInfo}
              setImageInfo={isEdit ? setImageInfo : () => {}}
            />
          </Box>
        )}
      </Grid>
    </Grid>
  )
}

export default HeroSectionForm
